import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import ParticlesAuth from "../ParticlesAuth";

import { useLocation, useNavigate } from "react-router-dom";

//import images
import logoLight from "../../../assets/images/logo-light.svg";

/**
 * React component for displaying a success message.
 * @component
 */
const BasicSuccessMsg = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const [message, setMessage] = useState("");
	useEffect(() => {
		if (location.state === null) {
			navigate("/login");
		} else {
			setMessage(location.state);
		}
	});

	document.title = "Success | Adcropper";
	return (
		<React.Fragment>
			<ParticlesAuth>
				<div className="auth-page-content mt-lg-5 mt-xs-5">
					<Container>
						<Row>
							<Col lg={12}>
								<div className="text-center mt-sm-5 mb-4 text-white-50">
									<div>
										<Link to="/dashboard" className="d-inline-block auth-logo">
											<img src={logoLight} alt="" height="40" />
										</Link>
									</div>
								</div>
							</Col>
						</Row>

						<Row className="justify-content-center">
							<Col md={8} lg={6} xl={5}>
								<Card className="mt-4">
									<CardBody className="p-4 text-center">
										<div className="avatar-lg mx-auto mt-2">
											<div className="avatar-title bg-light text-success display-3 rounded-circle">
												<i className="ri-checkbox-circle-fill"></i>
											</div>
										</div>
										<div className="mt-4 pt-2">
											<h4>Well done !</h4>
											<p className="text-muted mx-4">{message}</p>
											<div className="mt-4">
												<Link to="/login" className="btn btn-success w-100">Go Back</Link>
											</div>
										</div>
									</CardBody>
								</Card>
							</Col>
						</Row>
					</Container>
				</div>
			</ParticlesAuth>
		</React.Fragment >
	);
};

export default BasicSuccessMsg;